// Спека 02 §B0 — пиксели макета.
export const STARS_BLOCK_HEIGHT = 180
export const STAR_SIZE = 64
export const MASCOT_SIZE = 250

/** Позиции звёзд и координаты пунктирной нити в SVG viewBox 346×180 (см. мокап #b0). */
export const STAR_LEFT_PERCENT = 26
export const STAR_RIGHT_PERCENT = 74
export const THREAD_VIEWBOX = '0 0 346 180'
export const THREAD_LINE = { x1: 126, y1: 82, x2: 220, y2: 82 }
export const THREAD_DASH = '5 6'
